import { render, staticRenderFns } from "./DescStatistics.vue?vue&type=template&id=dc191894&scoped=true&"
import script from "./DescStatistics.vue?vue&type=script&lang=js&"
export * from "./DescStatistics.vue?vue&type=script&lang=js&"
import style0 from "./DescStatistics.vue?vue&type=style&index=0&id=dc191894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc191894",
  null
  
)

export default component.exports